import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { crosswalksStates } from '../../hooks/useCrosswalksHook';

const mappingsActions = mapDefaultValuesToActions(crosswalksStates);

export default reduxReducerHelper(mappingsActions, crosswalksStates);
